var __jsx = React.createElement;
import React, { useState, useEffect, useRef, forwardRef } from "react";
import { twMerge } from "tailwind-merge";
var debounce = function debounce(func, wait) {
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return func.apply(void 0, args);
    }, wait);
  };
};
var Tabs = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var tabs = _ref.tabs,
    _ref$enableScrollBeha = _ref.enableScrollBehaviour,
    enableScrollBehaviour = _ref$enableScrollBeha === void 0 ? false : _ref$enableScrollBeha,
    scrollPaddingTop = _ref.scrollPaddingTop,
    tabsTop = _ref.tabsTop,
    onTabClick = _ref.onTabClick,
    tabScrollMarginTop = _ref.tabScrollMarginTop,
    onScroll = _ref.onScroll;
  var _useState = useState(0),
    activeTab = _useState[0],
    setActiveTab = _useState[1];
  var tabRefs = useRef([]);
  useEffect(function () {
    if (!enableScrollBehaviour) return;
    var handleScroll = debounce(function () {
      var scrollPosition = window.scrollY + window.innerHeight / 2;
      tabRefs.current.forEach(function (tabRef, index) {
        if (tabRef) {
          var offsetTop = tabRef.offsetTop,
            offsetHeight = tabRef.offsetHeight;
          var visibleHeight = Math.min(offsetHeight, Math.max(0, scrollPosition - offsetTop));
          var visibilityPercentage = visibleHeight / offsetHeight * 100;
          if (visibilityPercentage >= 51) {
            onScroll && onScroll(tabRef);
            setActiveTab(index);
          }
        }
      });
    }, 300);
    window.addEventListener("scroll", handleScroll);
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [enableScrollBehaviour, tabs]);
  var handleTabClick = function handleTabClick(index, id) {
    setActiveTab(index);
    if (enableScrollBehaviour && tabRefs.current[index]) {
      var _tabRefs$current$inde;
      (_tabRefs$current$inde = tabRefs.current[index]) === null || _tabRefs$current$inde === void 0 ? void 0 : _tabRefs$current$inde.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
    onTabClick && onTabClick(id);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("flex border-b border-gray-200 pt-3 px-4 gap-5 lg:justify-center w-full sticky top-0 z-40 bg-white", tabsTop),
    ref: ref
  }, tabs.map(function (tab, index) {
    return /*#__PURE__*/React.createElement("div", {
      id: tab.id,
      key: "tab-".concat(index),
      onClick: function onClick() {
        return handleTabClick(index, tab.id);
      },
      className: twMerge("flex flex-col gap-2 cursor-pointer text-sm font-medium transition-colors duration-300 ease-in-out", activeTab === index ? "text-primary font-bold" : "text-neutral-90"),
      role: "tab",
      tabIndex: 0
    }, /*#__PURE__*/React.createElement("span", null, tab.label), /*#__PURE__*/React.createElement("div", {
      className: "h-0.5 w-full ".concat(activeTab === index ? "bg-primary text-primary" : "bg-transparent")
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: twMerge("relative p-4 pt-0 md:pt-4")
  }, tabs.map(function (tab, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      ref: function ref(el) {
        return tabRefs.current[index] = el;
      },
      id: tab.id,
      className: twMerge("transition-opacity duration-300 ease-in-out", enableScrollBehaviour ? "md:mt-8 mt-6" : "", tabScrollMarginTop),
      style: {
        position: "relative"
      },
      role: "tabpanel"
    }, tab.content);
  })));
});
export default Tabs;